import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

interface AuthRequiredModalProps {
  groupId: string;
  groupName: string;
  closeModal: () => void;
}

const AuthRequiredModal: React.FC<AuthRequiredModalProps> = ({
  groupId,
  groupName,
  closeModal,
}) => {
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();
  const activeTab = searchParams.get('activeTab') || 'expenses';

  const isHurryUp = activeTab === 'settlement';
  
  return (
    <div className="w-full flex flex-col gap-1">
      <h2 className="text-[22px] font-bold mb-4">{groupName}에 초대되었습니다.</h2>
      <p className="text-gray-800 mb-4 leading-6">
        간단한 회원가입 후 {isHurryUp ? '정산을 완료하세요!' : '그룹에 참여하세요!'}
        <br/>
        착오송금 방지를 위한 절차입니다 🥺
      </p>
      <button 
        className="w-full px-4 py-3.5 font-semibold bg-blue-500 text-white rounded-xl"
        onClick={() => {
          navigate('/auth', { state: { redirectUrl: `/groups/${groupId}` + (isHurryUp ? `?activeTab=settlement` : '') } })
          closeModal();
        }}
      >
        {isHurryUp ? '간편가입 후 정산하기' : '가입하러 가기'}
      </button>
    </div>
  );
};

export default AuthRequiredModal; 